import React from 'react';
import { Check } from 'lucide-react';
const base = ['5 Tomos completos', 'Bono 1 — Tarjetas Silábicas Imprimibles', 'Bono 2 — Carteles de Lectura para el Hogar', 'Bono 3 — Calendario de Progreso + Diploma'];
const premium = ['Tarjetas Extra', 'Juegos de Lectura', 'Mini Lecturas', 'Desafíos de 21 Días'];
export function WhatsIncluded() {
  const rows = Math.max(base.length, premium.length);
  return <section className="py-12 md:py-16 bg-white" data-id="element-347">
      <div className="container mx-auto px-4 max-w-4xl" data-id="element-348">
        <div className="text-center mb-8" data-id="element-349">
          <h2 className="text-2xl font-bold text-navy flex items-center justify-center gap-2" data-id="element-350">
            <Check className="w-6 h-6 text-emerald-500" data-id="element-351" />
            ¿QUÉ INCLUYE CADA UNO?
          </h2>
        </div>

        <div className="rounded-3xl border border-slate-100 overflow-hidden shadow-sm" data-id="element-352">
          <table className="w-full table-fixed border-collapse" data-id="element-353">
            <thead data-id="element-354">
              <tr data-id="element-355">
                <th className="w-1/2 bg-blue-50 border-b border-blue-100/70 px-3 py-4 sm:px-5 text-center" data-id="element-356">
                  <span className="text-xs sm:text-base font-bold text-blue-700" data-id="element-357">
                    📘 MIS PRIMERAS LECTURAS
                  </span>
                </th>
                <th className="w-1/2 bg-gold/10 border-b border-l border-gold/20 px-3 py-4 sm:px-5 text-center" data-id="element-358">
                  <span className="text-xs sm:text-base font-bold text-gold-600 block" data-id="element-359">
                    ⚡ KIT ACELERADOR
                  </span>
                  <span className="text-[10px] sm:text-xs font-normal text-slate-500" data-id="element-360">
                    Solo en versión Premium
                  </span>
                </th>
              </tr>
            </thead>
            <tbody data-id="element-361">
              {Array.from({
              length: rows
            }).map((_, i) => <tr key={i} className="align-top" data-id="element-362">
                  <td className="bg-blue-50/30 border-b border-blue-100/40 px-3 py-3 sm:px-5 sm:py-4" data-id="element-363">
                    {base[i] && <div className="flex items-start gap-2" data-id="element-364">
                        <Check className="w-4 h-4 sm:w-5 sm:h-5 text-emerald-500 flex-shrink-0 mt-0.5" data-id="element-365" />
                        <span className="text-xs sm:text-base text-slate-700 leading-snug" data-id="element-366">
                          {base[i]}
                        </span>
                      </div>}
                  </td>
                  <td className="bg-gold/[0.04] border-b border-l border-gold/10 px-3 py-3 sm:px-5 sm:py-4" data-id="element-367">
                    {premium[i] && <div className="flex items-start gap-2" data-id="element-368">
                        <Check className="w-4 h-4 sm:w-5 sm:h-5 text-gold flex-shrink-0 mt-0.5" data-id="element-369" />
                        <span className="text-xs sm:text-base text-slate-700 leading-snug" data-id="element-370">
                          {premium[i]}
                        </span>
                      </div>}
                  </td>
                </tr>)}
            </tbody>
          </table>
        </div>
      </div>
    </section>;
}